import { useMemo } from 'react';

import { useNavPanel } from '@/context/NavPanelProvider';
import { buildTypePredicate } from '@/util/type';

export const panelViewModes = ['resources', 'fileTree', 'database'] as const;
export type PanelViewMode = (typeof panelViewModes)[number];

const isPanelViewMode = buildTypePredicate(panelViewModes);

export const getPanelViewMode = (
  input: string | undefined | null,
): PanelViewMode | null => {
  return isPanelViewMode(input) ? input : null;
};

export const usePanelView = () => {
  const { navMode, updateNavMode } = useNavPanel();

  return useMemo(() => {
    return [navMode, updateNavMode] as const;
  }, [navMode, updateNavMode]);
};
